import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import {Pie} from 'react-chartjs-2';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
import {NavLink, Link} from 'react-router-dom';


class Home extends Component {
    constructor(props) {
        super(props);



        this.state={
           user_details:this.props.user_details,
           access_token:this.props.access_token,
           loading:false,
           api_error:false,
           loaded_successfully:false,
           api_error_message:"",

        }
     }

  render() {
    const _this=this;

    return (
      <div className="main-panel">

        <Header title ="My Profile" />

        <div className="content">
            <div className="container-fluid">
                <div className="row">

                    <div className="col-lg-12 col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title text-center">My Profile</h4>
                            </div>
                           <div className="card-body">

                            <div className = "row col-lg-12 col-sm-12 col-sm-12">

                                <div className = "col-lg-6">
                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Staff Number :
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.EmpNo}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles content-line">
                                              Name :
                                          </span>
                                          <span className = "content-text ">
                                            {_this.props.staff_details.core_details.Names}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Title:
                                          </span>
                                          <span className = "content-text ">
                                            {_this.props.staff_details.core_details.JobTitle}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Department:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.Department}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Section:
                                          </span>
                                          <span className = "content-text ">
                                            {_this.props.staff_details.core_details.Section}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Hiring Date :
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.HDate}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              KRA PIN Number :
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.PIN}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = " content-titles">
                                              NHIF:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.NHIF}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              NSSF:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.NSSF}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              VISA :
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.VISA}
                                          </span>
                                      </div>

                                </div>



                                <div className = "col-lg-6">
                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = " content-titles">
                                              Personal Email:
                                          </span>
                                          <span className = "content-text content-line">
                                            {_this.props.staff_details.core_details.PEmail}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Work Email:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.WEmail}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Gender:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.Gender}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Telephone Number:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.WTel}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              National ID:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.IDNo}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              DOB:
                                          </span>
                                          <span className = "content-text">
                                            {(_this.props.staff_details.core_details.DOB).split("T")[0]}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Country:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.Country}
                                          </span>
                                      </div>


                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "content-titles">
                                              Postal Address:
                                          </span>
                                          <span className = "content-text">
                                            {_this.props.staff_details.core_details.Address}
                                          </span>
                                      </div>
                                </div>



                            </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <Footer/>

      </div>
    );
  }
}

export default Home;
